import React, { useRef } from 'react';
import { AVATAR_PREVIEW, type Character } from '../Assets/Avatars';
import { useAvatar } from '../context/AvatarContext';
import { useFocusTrap } from '../lib/useFocusTrap';

const TILES: { id: Character; name: string; tagline: string }[] = [
  { id: 'fizz', name: 'Fizz', tagline: 'soft-spoken bubble bee · vibes with chill code' },
  { id: 'buzz', name: 'Buzz', tagline: 'caffeinated stripe-bee · vibes with cracked grinds' },
];

const AvatarPicker: React.FC = () => {
  const { setCharacter } = useAvatar();
  const dialogRef = useRef<HTMLDivElement>(null);
  useFocusTrap(dialogRef, true);

  return (
    <div
      ref={dialogRef}
      role="dialog"
      aria-modal="true"
      aria-label="Choose your buddy"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(30,27,22,0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: 20,
      }}
    >
      <div
        className="sk-box shadow"
        style={{
          background: 'var(--paper)',
          padding: 28,
          maxWidth: 520,
          width: '100%',
          border: '1.6px solid var(--ink)',
        }}
      >
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, letterSpacing: '-0.02em' }}>
          choose your buddy
        </h2>
        <p style={{ margin: '6px 0 18px', fontSize: 12, color: 'var(--ink-soft)' }}>
          who you pick rides with you across the island. you can change later in your profile.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          {TILES.map(t => (
            <button
              key={t.id}
              onClick={() => setCharacter(t.id)}
              className="sk-box"
              style={{
                background: 'var(--paper-2)',
                padding: 14,
                border: '1.4px solid var(--ink)',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 8,
                fontFamily: 'inherit',
              }}
              aria-label={`Pick ${t.name}`}
            >
              <img
                src={AVATAR_PREVIEW[t.id]}
                alt=""
                width={120}
                height={132}
                style={{ display: 'block' }}
              />
              <div style={{ fontWeight: 700, fontSize: 15 }}>{t.name}</div>
              <div
                style={{
                  fontSize: 10,
                  color: 'var(--ink-soft)',
                  fontStyle: 'italic',
                  textAlign: 'center',
                  lineHeight: 1.35,
                }}
              >
                "{t.tagline}"
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AvatarPicker;
